import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import Styles from "./TableGeralDataWithQRCode.module.css";

const useStyles = makeStyles((theme) => ({
	tableActions: {
		width: "100%",
	},
}));

const TableGeralDataWithQrCode = (props) => {
	const classes = useStyles();

	// console.log("TableGeralDataWithQrCode", props);

	return (
		<div className={Styles["QrCodeTable"]}>
			<Table className={classes.table} aria-label="Actions table">
				<TableHead>
					<TableRow className={Styles["MuiTableRow-head"]}>
						<TableCell
							className={Styles["MuiTableCell-head"]}
							align="left"
						>
							<div className={Styles["title"]}>Dados Gerais</div>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					<TableRow className={Styles["MuiTableBody-root"]}>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
						>
							<div className={Styles["tableCell-height"]}>
								<div className={Styles["title"]}>
									Metodologia
								</div>
								<div className={Styles["subtitle"]}>
									{
										props.TableGeralDataWithQrCodeData
											.pageData.modality.name
									}
								</div>
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
						>
							<div className={Styles["tableCell-height"]}>
								<div className={Styles["title"]}>Estado</div>
								<div className={Styles["subtitle"]}>
									{
										props.TableGeralDataWithQrCodeData
											.pageData.enrollmentStatus.nome
									}
								</div>
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
						>
							<div className={Styles["tableCell-height"]}>
								<div className={Styles["title"]}>
									Data de Inicio
								</div>
								<div className={Styles["subtitle"]}>
									{
										props.TableGeralDataWithQrCodeData
											.pageData.shortStartDate
									}
								</div>
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
						>
							<div className={Styles["tableCell-height"]}>
								<div className={Styles["title"]}>
									Data de Fim
								</div>
								<div className={Styles["subtitle"]}>
									{
										props.TableGeralDataWithQrCodeData
											.pageData.shortEndDate
									}
								</div>
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
						>
							<div className={Styles["tableCell-height"]}>
								<div className={Styles["title"]}>
									Total de Horas
								</div>
								<div className={Styles["subtitle"]}>
									{
										props.TableGeralDataWithQrCodeData
											.pageData.durationSpan
									}
								</div>
							</div>
						</TableCell>
					</TableRow>

					<TableRow className={Styles["MuiTableBody-root"]}>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
							style={{ verticalAlign: "baseline" }}
						>
							<div className={Styles["tableCell-height"]}>
								<div className={Styles["title"]}>
									Resultado/ Nota
								</div>
								<div className={Styles["subtitle"]}>
									{
										props.TableGeralDataWithQrCodeData
											.pageData.grade
									}
								</div>
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
							style={{ verticalAlign: "baseline" }}
						>
							<div className={Styles["tableCell-height"]}>
								<div className={Styles["title"]}>
									Nº Certificado
								</div>
								{props.TableGeralDataWithQrCodeData.pageData
									.certificateNumber && (
									<div>
										<div className={Styles["subtitle"]}>
											{props.TableGeralDataWithQrCodeData
												.pageData.certificateNumber
												? props
														.TableGeralDataWithQrCodeData
														.pageData
														.certificateNumber
												: "..."}
										</div>
										<div
											className={Styles["subtitle"]}
											style={{ marginBottom: "10px" }}
										>
											<img
												src={
													props
														.TableGeralDataWithQrCodeData
														.pageData.base64QrCode
												}
												style={{
													width: "110px",
													height: "110px",
													marginLeft: "-9px",
												}}
											/>
										</div>
									</div>
								)}
							</div>
						</TableCell>
						<TableCell
							className={Styles["MuiTableCell-root"]}
							align="left"
							component="th"
							style={{ verticalAlign: "baseline" }}
						>
							<div className={Styles["tableCell-height"]}>
								<div className={Styles["title"]}>Tipo</div>
								<div className={Styles["subtitle"]}>
									<div
										className={`${Styles["subtitle"]} ${Styles["former-avatar"]}`}
									>
										{props.TableGeralDataWithQrCodeData
											.pageData.trainingType ===
										"Enumerable.TrainingType.Program"
											? "Curso"
											: "Módulo"}
									</div>
								</div>
							</div>
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</div>
	);
};

export default TableGeralDataWithQrCode;
